__turbopack_context__.v({
  "alert": "tED_5q_alert",
  "artist": "tED_5q_artist",
  "container": "tED_5q_container",
  "face": "tED_5q_face",
  "heading": "tED_5q_heading",
  "isSelected": "tED_5q_isSelected",
  "option": "tED_5q_option",
  "optionList": "tED_5q_optionList",
  "revert": "tED_5q_revert",
  "setName": "tED_5q_setName",
});
